// 207 §1.2 — THE ONE RULE FOR A TEMPORARY ID: IT CAN NEVER EQUAL A SERVER ID.
//
// A row the list sync (`persist` / `s()`, src/App.tsx) is about to POST needs an
// id to sit in the list under until the server answers; the create branch then
// swaps that id for the server's (`x.id === id ? saved : x`) and de-duplicates
// by id, first wins. Every such id used to be `max(ids the browser holds) + 1`,
// `+2` … (`nid()`, src/utils.ts, and two local counters) — THE SAME NUMBER RANGE
// THE SERVER HANDS OUT. When the server's next id ran k ahead of the highest id
// the page held (a client it never loaded, one deleted, a sequence that moved),
// each server id landed on the temporary id of a row still waiting, the
// de-duplication dropped one of the two, and the browser's list lost every row
// but the last k. Brief 207 §1.1 measured exactly that on the shadow, through
// the real collective-case import: k = 5 → 5 of 253 members listed, the server
// holding all 253; k = 12 (WebKit) → 12 of 253.
//
// So a temporary id is NEGATIVE, from one counter for the whole page, strictly
// decreasing: never a server id (the sequences hand out 1, 2, 3 …), never
// another temporary id (one counter, every entity kind, the page's lifetime).
// It starts at −2, not −1, because the ONE non-positive id the database holds is
// the tenancy canary's marker row, −1 in every scoped table
// (server/tenancy/generate-canary.js:3) — no page can hold it (it lives in the
// canary tenant, which serves no session), and the rule does not rest on that.
//
// A negative number, not a string, so every reader that types an id as a
// `number` — `Map<number, …>` keys, `typeof id === "number"`, `+id` — keeps
// working unchanged through the moment the row waits.
//
// NOT FOR ELEMENTS INSIDE A ROW. A stage, a document or a web link inside a
// matter's JSON (`stages`, `docs`, `links`) takes a PERMANENT id that no server
// ever replaces — tasks and events name a stage by it (`stageId`) — and that id
// stays `nid()`'s. The census that split the two is in 207 §1.2's commit.
let last = -1;

export function tempId(): number {
  last -= 1;
  return last;
}
